import { motion } from "framer-motion";

/** Orbital backdrop using REAL IYAF brand colors (blue/orange/gray/magenta dots). */
export function OrbitalBackdrop({ className = "", subtle = false }) {
  const dots = [
    { color: "#3663A8", x: 0, y: -220 },  // Hub
    { color: "#FF9F1C", x: 240, y: 60 },  // Social
    { color: "#8C8C8C", x: -200, y: 130 },// Consult
    { color: "#E01E84", x: 90, y: 260 },  // Venture
  ];
  const op = subtle ? 0.07 : 0.16;
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden>
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <motion.div
          className="rounded-full"
          style={{ width: 760, height: 760, border: `1px dashed rgba(54,99,168,${op})` }}
          animate={{ rotate: 360 }}
          transition={{ duration: 180, ease: "linear", repeat: Infinity }}
        />
      </div>
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <motion.div
          className="rounded-full"
          style={{ width: 540, height: 540, border: `1px solid rgba(17,24,39,${op})` }}
          animate={{ rotate: -360 }}
          transition={{ duration: 240, ease: "linear", repeat: Infinity }}
        />
      </div>
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <motion.div className="relative" animate={{ rotate: 360 }} transition={{ duration: 60, ease: "linear", repeat: Infinity }} style={{ width: 1, height: 1 }}>
          {dots.map((d, i) => (
            <div key={i} className="absolute rounded-full" style={{ width: 14, height: 14, background: d.color, left: d.x, top: d.y, boxShadow: `0 0 28px ${d.color}66` }} />
          ))}
        </motion.div>
      </div>
    </div>
  );
}

export function RotatingRing({ size = 240, color = "#3663A8", thickness = 1, className = "", duration = 90, dashed = true }) {
  return (
    <motion.div
      className={`rounded-full pointer-events-none ${className}`}
      style={{ width: size, height: size, border: `${thickness}px ${dashed ? "dashed" : "solid"} ${color}` }}
      animate={{ rotate: 360 }}
      transition={{ duration, ease: "linear", repeat: Infinity }}
      aria-hidden
    />
  );
}
